module.exports = __webpack_public_path__ + "static/media/3ddocs_gray.a101c134.png";